import React from 'react';
import './index.scss';

import { PMARK } from 'utils/constant';
import logoRecruit from 'assets/logo-recruit.png';
import PcButtonArea from 'components/molecules/PcButtonArea';

let privacy = "";
const domain = document.domain;
if (domain.match(/^localhost/) || domain.match(/^www-dev./)) {
  privacy = PMARK.DEV;
} else if (domain.match(/^www-stg./)) {
  privacy = PMARK.STG;
} else if (domain.match(/^www./)) {
  privacy = PMARK.MAIN;
}

const PcFooter = ({
  onClickMainButton = {},
  nextUrl,
  prevUrl,
  valid,
  buttonType,
}) => (
  <div className="PcFooter">
    <div className="button-area">
      <PcButtonArea
        onClickMainButton={onClickMainButton}
        prevUrl={prevUrl}
        nextUrl={nextUrl}
        buttonType={buttonType}
        valid={valid}
      />
    </div>
    <div className="pc-footer-horizon" />
    <div className="pc-footer-wrapper">
      <div className="logo-area">
        <a href="/corporate/" target="_blank" rel="noopener noreferrer">
          <img className="logo-recruit" src={logoRecruit} alt="logo-recruit" />
        </a>
        <a href="/corporate/" target="_blank" rel="noopener noreferrer">
          <div className="company-limited">(C) Recruit Staffing Co., Ltd.</div>
        </a>
      </div>
      <div className="map-area">
        <ul className="url-area">
          <li><a href="/sol/cont/privacy/">プライバシーポリシー</a></li>
          <li>|</li>
          <li><a href="/sol/cont/terms/">ご利用にあたって</a></li>
        </ul>
        <a rel="noopener noreferrer" target="_blank" href="https://privacymark.jp/">
          <img className="logo-privacy" src={privacy} alt="logo-recruit" />
        </a>
      </div>
    </div>
  </div>
);

export default PcFooter;